const StringUtils = {}

/**
 * Hàm trả về Từ được biến đổi về dạng Tiếng Việt không dấu
 * 
 * @param {String} str - từ muốn chuyển về dạng không dấu
 * @returns {String} Từ được biến đổi về dạng Tiếng Việt không dấu
 * 
 * Ví dụ 
 *  removeAccents('Thành Bùi') = 'Thanh bui'
 */
StringUtils.removeAccents = (str) => {
  try {
    if (str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D')
    }
  } catch (e) {
    console.log(str, e)
  }

  return ''
}

/**
 * Hàm trả về kết quả Câu str có chứa từ khóa key dạng tiếng Việt không dấu hay không
 * Ví dụ:
 *  noAccentsMatch('Thành Bùi', 'hân') = true, do 'Thành Bùi' chuyển sang không dấu là 'thanh bui', 'hân' chuyển sang không dấu là 'han', 'thanh bui' có chứa 'han' nên trả về true
 *  noAccentsMatch('Thành Bùi', 'ah') = false, do 'Thành Bùi' chuyển sang không dấu là 'thanh bui', 'ah' chuyển sang không dấu là 'ah', 'thanh bui' có chứa 'ah' nên trả về true
 * 
 * 
 * @param {String} str - từ muốn kiểm tra có chứa từ khóa hay không
 * @param {String} key - từ khóa 
 * @param {boolean} isNoAccentsKey - nếu từ khóa đã được chuyển về dạng tiếng Việt không dấu, truyền true
 * 
 * @returns {Boolean}
 */
StringUtils.noAccentsMatch = (str, key, isNoAccentsKey = false) => {
  const noAccentsKey = isNoAccentsKey ? key.toLowerCase() : StringUtils.removeAccents(key).toLowerCase()
  return StringUtils.removeAccents(str).toLowerCase().includes(noAccentsKey)
}

StringUtils.capitalizeFirstLetter = (str) => {
  const result = str.charAt(0).toUpperCase() + str.slice(1)
  return result
}

StringUtils.randomString = (length) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

StringUtils.randomNumberStr = (length) => {
  let text = '';
  const possible = '0123456789';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

export default StringUtils